var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8155 0.0761718C3.27904 0.658421 0 4.73977 0 9.31343V13.5C0 16.1913 1.03336 18 2.57143 18H6.42857V8.99997H2.57143C2.57143 5.45545 5.45548 2.57141 9 2.57141C12.5445 2.57141 15.4286 5.45545 15.4286 8.99997H11.5714V18H15.4286C16.9666 18 18 16.1913 18 13.4999V8.99997C18 3.64764 13.3039 -0.628274 7.8155 0.0761718Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.c70e4f98353dd8259797cb3e5e0e6b11.svg";
export { ForwardRef as ReactComponent };